import React from "react"

const Videos = ({ video, ...props }) => {
  return (
    <iframe
      style={{
        background: `${video.color_fondo_marco}`,
        padding: 15,
        height: "100%",
        width: "100%",
      }}
      src={video.link}
      title={video.nombre}
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      frameBorder="0"
      webkitallowfullscreen="true"
      mozallowfullscreen="true"
      allowFullScreen
    />
  )
}

export default Videos
